/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {


  async fetchTotalSuppliesOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/suppliesOrder/getTotalSuppliesOrder`
      )
      payload.loading.close()
      commit('SET_TOTAL_SUPPLIES_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },


  async fetchSuppliesOrder({ commit }, payload) {
    
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/suppliesOrder/getSuppliesOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_SUPPLIES_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },
  async addNewSuppliesOrder({ commit }, payload) {
 
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/suppliesOrder/save`, payload.order)
      payload.order.idSuppliesOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_SUPPLIES_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/suprimentos`).catch(() => { });
  },



  async removeSuppliesOrder({ commit }, payload) {
    let idSuppliesOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/suppliesOrder/remove`, { idSuppliesOrder })
      payload.loading.close()
      commit('REMOVE_SUPPLIES_ORDER', idSuppliesOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updateSuppliesOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/suppliesOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_SUPPLIES_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      //console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/suprimentos`).catch(err => { });
  },

  async trashSuppliesOrder({ commit }, payload) {
    let idSuppliesOrder = payload.idOrder
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/suppliesOrder/trash`,{ idSuppliesOrder }
      )
      payload.loading.close()
      commit('REMOVE_SUPPLIES_ORDER', idSuppliesOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },

  async fetchSuppliesOrderByPeriod({ commit }, payload) {
    try {
      payload.loading()
      const response = await axios.post(
        `${baseApiUrl}/suppliesOrder/getSuppliesOrderedByPeriod`,
        payload.data
      );
      payload.loading.close()
      commit('SET_SUPPLIES_ORDER_FILTERED', response.data)
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/suprimentos").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },

  async trashFilteredSuppliesOrder({ commit }, payload) {
    let idSuppliesOrder = payload.idOrder
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/suppliesOrder/trash`,{ idSuppliesOrder }
      )
      payload.loading.close()
      commit('REMOVE_SUPPLIES_ORDER_FILTERED', idSuppliesOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/suprimentos").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },
}
